export enum GroupTermElementTypeEnum {
    FunctionTerm = "function-term",
    Environment = "environment",
    Other = "Other",
}